/**
 * External dependencies
 */
import inherits from 'inherits';

export default class PlanNames {
    constructor(cscom) {
        if (!(this instanceof PlanNames)) {
            return new PlanNames(cscom);
        }
        this.cscom = cscom;
    }

    list(data) {
        return this.cscom.req.get('/customer-site-api/plan-names/list', null, data);
    }

}
